/**
 * Shared React Query staleTime tiers for DentXE web.
 *
 * Policy: docs/adr/ADR-003-reference-data-caching.md
 * Prefer these constants over magic numbers in feature hooks.
 */
export const QUERY_STALE_MS = {
  /** Global seed / public reference (geo, future global templates). */
  REFERENCE: 86_400_000, // 24h
  /** Org-scoped catalogs used in pickers (conditions, allergies, procedure catalog). */
  CATALOG: 300_000, // 5m
  /** Rarely edited org catalogs when a longer private TTL is justified. */
  CATALOG_LONG: 900_000, // 15m
  /** Live operational lists (appointments, queue-adjacent). */
  HOT: 30_000, // 30s
} as const;
